var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page"},[_c('Icon',{attrs:{"name":"404"}}),_c('router-link',{staticClass:"toDetail",attrs:{"to":"/"}},[_c('em',[_vm._v("点击此处返回首页")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }